import axios from 'axios';

import { createException, ExceptionsTypes } from './Exceptions';
import { validateConfig } from './validators';

let appAxios;

class NetworkRequest {
  static configureDAF(config = {}) {
    if (validateConfig(config)) {
      appAxios = axios.create({
        baseURL: config.baseURL,
        timeout: config.timeout,
        headers: config.headers,
      });
    } else {
      createException(ExceptionsTypes.BadRequest, 'invalid parametars');
    }
  }

  static getNetworkUrl(url = '') {
    const externalApi = /^http/i.test(url);
    return externalApi ? axios : appAxios;
  }
}

NetworkRequest.appAxios = axios;

export default NetworkRequest;
